//initial redux
import { put, call, takeEvery, fork, take, all, takeLatest, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import { types as sitetreetypes } from "../../../services/SiteTree/redux";
import {types as tarifftypes } from "../../Tariffs/redux";
import moment from "moment";
import pointsservice from "../../../services/points";
import ticketservice from "../../../services/ticket";
import { getSecondsWithOptions } from "date-fns/esm/fp";
import takeLeading from "../../../utils/takeLeading";

const LIVE_DATA_INTERVAL = 15000;
const DAYS = 7;

const initialState = {
	columnHeaders: [],
	usagePointId: null,
	ambientTemperaturePointId: null,
	costs: new Array(DAYS),
	tickets: new Array(DAYS),
	usage: new Array(DAYS),
	ambientMin: new Array(DAYS),
	ambientAvg: new Array(DAYS),
	ambientMax: new Array(DAYS),
	onPage: false,
	isBusy: false,
	errors: [],
	hasError: false
};

/////////
//types
export const types = {
	START_COMPONENT: "components/weeklysummarytable/START_COMPONENT",
	STOP_COMPONENT: "components/weeklysummarytable/STOP_COMPONENT",
	SET_COLUMN_HEADERS: "components/weeklysummarytable/SET_COLUMN_HEADERS",
	UPDATE_COLUMN_HEADERS:  "components/weeklysummarytable/UPDATE_COLUMN_HEADERS",
	SET_POINT_IDS: "components/weeklysummarytable/SET_POINT_IDS",
	UPDATE_LIVE_DATA:  "components/weeklysummarytable/UPDATE_LIVE_DATA",
	SET_COSTS: "components/weeklysummarytable/SET_COSTS",
	SET_TICKETS: "components/weeklysummarytable/SET_TICKETS",
	SET_USAGE: "components/weeklysummarytable/SET_USAGE",
	SET_AMBIENT_MIN: "components/weeklysummarytable/SET_AMBIENT_MIN",
	SET_AMBIENT_AVG: "components/weeklysummarytable/SET_AMBIENT_AVG",
	SET_AMBIENT_MAX: "components/weeklysummarytable/SET_AMBIENT_MAX",
	UPDATE_LIVE_COSTS: "components/weeklysummarytable/UPDATE_LIVE_COSTS",
	UPDATE_LIVE_TICKETS: "components/weeklysummarytable/UPDATE_LIVE_TICKETS",
	UPDATE_LIVE_USAGE: "components/weeklysummarytable/UPDATE_LIVE_USAGE",
	UPDATE_LIVE_AMBIENT_MIN: "components/weeklysummarytable/UPDATE_LIVE_AMBIENT_MIN",
	UPDATE_LIVE_AMBIENT_AVG: "components/weeklysummarytable/UPDATE_LIVE_AMBIENT_AVG",
	UPDATE_LIVE_AMBIENT_MAX: "components/weeklysummarytable/UPDATE_LIVE_AMBIENT_MAX",
	UPDATE_LIVE_TICKETS_FAILED: "components/weeklysummarytable/UPDATE_LIVE_TICKETS_FAILED",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.START_COMPONENT:{
				return {...state, onPage: true};
			}
			case types.STOP_COMPONENT:{
				return {...state, onPage: false};
			}
			case types.SET_COLUMN_HEADERS:{
				return {...state, columnHeaders: action.payload.columnHeaders};
			}
			case types.UPDATE_COLUMN_HEADERS:{
				return state;
			}
			case types.SET_POINT_IDS:{
				return {...state, usagePointId: action.payload.usagePointId, ambientTemperaturePointId: action.payload.ambientTemperaturePointId};
			}
			case types.UPDATE_LIVE_DATA: {
				return state;
			}
			case types.SET_COSTS:{
				return {...state, costs: action.payload.costs};
			}
			case types.SET_TICKETS:{
				return {...state, tickets: action.payload.tickets};
			}
			case types.SET_USAGE:{
				return {...state, usage: action.payload.usage};
			}
			case types.SET_AMBIENT_MIN:{
				return {...state, ambientMin: action.payload.ambientMin};
			}
			case types.SET_AMBIENT_AVG:{
				return {...state, ambientAvg: action.payload.ambientAvg};
			}
			case types.SET_AMBIENT_MAX:{
				return {...state, ambientMax: action.payload.ambientMax};
			}
			case types.UPDATE_LIVE_COSTS:{
				return {...state, costs: {...state.costs, [DAYS - 1]: action.payload.liveCost}};
			}
			case types.UPDATE_LIVE_TICKETS:{
				return {...state, tickets: {...state.tickets, [DAYS - 1]: action.payload.liveTickets}};
			}
			case types.UPDATE_LIVE_USAGE:{
				return {...state, usage: {...state.usage, [DAYS - 1]: action.payload.liveUsage}};
			}
			case types.UPDATE_LIVE_AMBIENT_MIN:{
				return {...state, ambientMin: {...state.ambientMin, [DAYS - 1]: action.payload.liveAmbientMin}};
			}
			case types.UPDATE_LIVE_AMBIENT_AVG:{
				return {...state, ambientAvg: {...state.ambientAvg, [DAYS - 1]: action.payload.liveAmbientAvg}};
			}
			case types.UPDATE_LIVE_AMBIENT_MAX:{
				return {...state, ambientMax: {...state.ambientMax, [DAYS - 1]: action.payload.liveAmbientMax}};
			}
			default:
				return state;
		}
	}
};

function getView(flattenedSiteTree, rootView, paths){
	let result = null;

	let wkView = rootView;
	if(flattenedSiteTree && rootView && paths && paths.length && flattenedSiteTree.Roots.length){
		for(var ii = 0; ii < paths.length; ii++){
			let wkPath = paths[ii];
         let nextView = null;
         
         const childs = flattenedSiteTree.GetChildrenFor(wkView);

         for (let index = 0; index < childs.length; index++) {
            const childView = childs[index];
            if(childView.name === wkPath){
               nextView = childView;
               break;
            }
         }

			if(!nextView){
				break;
			}else{
				wkView = nextView;
			}
			if(ii === paths.length - 1){
				result = wkView;
			}
		}
	}

	return result;
}

function* getCosts(pointId, tariffId, tariffVersionId, fromDate, toDate){
	const dailyCost = yield call(pointsservice.TrendableDataGetData, pointId, fromDate, toDate, tariffId, tariffVersionId, "Daily", true);
	return sortCosts(dailyCost);
}

function* getUsage(pointId, fromDate, toDate){
	const dailyUsage = yield call(pointsservice.TrendableDataGetData, pointId, fromDate, toDate, null, null, "Daily", true);
	return dailyUsage;
}

//turns the shitty ibms data into a timestamp-ordered array of objects
function sortCosts(costs){
	let sorted = [];

	//if nothing then nope
	if(!costs){
		return sorted;
	}

	for(var something in costs) {
		if(costs.hasOwnProperty(something)) {
			costs[something].forEach(s => {
				let costObj = {
					timestamp: new Date(s.timestamp),
					value: Number(s.value)
				};
				let matchingDate = sorted.find(t => {return costObj.timestamp.getTime() === t.timestamp.getTime()});
				if(matchingDate){
					matchingDate.value += costObj.value;
				}else{
					sorted.push(costObj);
				}
			});
		}
	}
/*
	//grab the 3 periods
	const offPeak = costs["OffPeak"];
	const peak = costs["Peak"];
	const shoulder = costs["Shoulder"];

	//loop over all periods and add to same array while castign timestamps to moment objects and adding the period as a prop.
	if(offPeak && offPeak.length){
		offPeak.forEach(s => {
			sorted.push({
				timestamp: new Date(s.timestamp),
				value: Number(s.value)
			});
		});
	}

	if(peak && peak.length){
		peak.forEach(s => {
			let costObj = {
				timestamp: new Date(s.timestamp),
				value: Number(s.value)
			};
			let matchingDate = sorted.find(t => {return costObj.timestamp.getTime() === t.timestamp.getTime()});
			if(matchingDate){
				matchingDate.value += costObj.value;
			}else{
				sorted.push(costObj);
			}
		});
	}

	if(shoulder && shoulder.length){
		shoulder.forEach(s => {
			let costObj = {
				timestamp: new Date(s.timestamp),
				value: Number(s.value)
			};
			let matchingDate = sorted.find(t => {return costObj.timestamp.getTime() === t.timestamp.getTime()});
			if(matchingDate){
				matchingDate.value += costObj.value;
			}else{
				sorted.push(costObj);
			}
		});
	}
*/
	//now sort the array
	sorted.sort(function(a, b){
		return a.timestamp > b.timestamp ? 1 : -1;
	});

	return sorted;
}


//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.startLiveDataInterval(),
			this.loadColumnHeaders(),
			this.checkNewDay(),
			this.loadPointIds(),
			this.loadCostsHistory(),
			this.updateLiveCosts(),
			this.loadTicketsHistory(),
			this.updateLiveTickets(),
			this.loadUsageHistory(),
			this.updateLiveUsage(),
			this.loadAmbientMinHistory(),
			this.updateLiveAmbientMin(),
			this.loadAmbientAvgHistory(),
			this.updateLiveAmbientAvg(),
			this.loadAmbientMaxHistory(),
			this.updateLiveAmbientMax(),
		]);
	},
	*startLiveDataInterval(){
		yield takeLatest(types.START_COMPONENT, function*(){
			for(;;){
				const onPage = yield select(x => x.weeklysummarytable.onPage);
				if(onPage){
					yield put(actions.updateLiveData());
				}else{
					break;
				}
				yield delay(LIVE_DATA_INTERVAL);
			}
		});
	},
	*loadColumnHeaders(){
		yield takeLatest([types.START_COMPONENT, types.UPDATE_COLUMN_HEADERS], function*(){
			let columnHeaders = [];
			for(var ii = DAYS - 1; ii >= 0; ii--){
				let startOfDay = moment().subtract(ii, 'days').startOf('day');
				let endOfDay = moment().subtract(ii, 'days').endOf('day');
				columnHeaders.push({
					text: startOfDay.format("ddd"),
					startOfDay: startOfDay,
					endOfDay: endOfDay
				});
			}
			yield put(actions.setColumnHeaders(columnHeaders));

		});
	},
	*checkNewDay(){
		yield takeLatest(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			if(columnHeaders && columnHeaders.length){
				if(columnHeaders[columnHeaders.length - 1].text !== moment().startOf('day').format("ddd")){
					yield put(actions.updateColumnHeaders());
				}
			}
		});
	},
	*loadPointIds(){
		yield takeLatest([types.START_COMPONENT, sitetreetypes.SET_CURRENT_SITE, sitetreetypes.ON_LOAD], function*(){
			const onPage = yield select(x => x.weeklysummarytable.onPage);
			if(!onPage){
					return;
			}
			const currentSite = yield select(x => x.sitetree.currentSite);
			const flattenedSiteTree =  yield select(x => x.sitetree.flattenedSiteTree);
			const usageView = getView(flattenedSiteTree, currentSite, ["Meters", "Main"]);
			const temperatureView = getView(flattenedSiteTree, currentSite, ["Ambient", "DegC"]);
			let usagePointId = usageView ? usageView.objectID : null;
			let ambientTemperaturePointId = temperatureView ? temperatureView.objectID : null;
			yield put(actions.setPointIds(usagePointId, ambientTemperaturePointId));
		});
	},
	*loadCostsHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS, tarifftypes.SET_TARIFF], function*(){
			const onPage = yield select(x => x.weeklysummarytable.onPage);
			if(!onPage){
					return;
			}
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const currentTariff = yield select(x => x.tariffs.currentTariff);
			const currentTariffVersion = yield select(x => x.tariffs.currentTariffVersion);
			const usagePointId = yield select(x => x.weeklysummarytable.usagePointId);
			let costs = new Array(DAYS);
			if(columnHeaders && columnHeaders.length && currentTariff && usagePointId){
				let fromDate = columnHeaders[0].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyCosts = yield call(getCosts, usagePointId, currentTariff.tariffPK, currentTariffVersion, fromDate, toDate);
				if(dailyCosts && dailyCosts.length){
					costs = [];
					dailyCosts.forEach(cost => {
						costs.push(cost.value)
					});
				}
			}
			yield put(actions.setCosts(costs));
		});
	},
	*updateLiveCosts(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const currentTariff = yield select(x => x.tariffs.currentTariff);
			const currentTariffVersion = yield select(x => x.tariffs.currentTariffVersion);
			const usagePointId = yield select(x => x.weeklysummarytable.usagePointId);
			if(columnHeaders && columnHeaders.length && currentTariff && usagePointId){
				let fromDate = columnHeaders[columnHeaders.length - 1].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyCosts = yield call(getCosts, usagePointId, currentTariff.tariffPK, currentTariffVersion, fromDate, 'now');
				if(dailyCosts && dailyCosts.length && dailyCosts[0].value !== undefined && dailyCosts[0] !== null){
					let liveCost = dailyCosts[0].value;
					yield put(actions.updateLiveCost(liveCost));
				}
			}
		});
	},
	*loadTicketsHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS], function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const currentSite = yield select(x => x.sitetree.currentSite);
			const livePageConf = yield select(x => x.live.livePageConf);			
			let tickets = new Array(DAYS);

			if(columnHeaders && columnHeaders.length && currentSite && livePageConf.ticketsIncluded){
				let dailyTickets = yield all([columnHeaders.map((header) => call(ticketservice.GetTicketsSold, [currentSite.name], header.startOfDay, header.endOfDay))]);
				if(dailyTickets && dailyTickets.length){
					dailyTickets = dailyTickets[0];
				}
				if(dailyTickets && dailyTickets.length){
					tickets = [];
					let wkSiteName = 's' + currentSite.name.substring(1);
					dailyTickets.forEach(s => {
						tickets.push(s[wkSiteName]);
					});
				}
			} 
			yield put(actions.setTickets(tickets));
		});
	},
	*updateLiveTickets(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const currentSite = yield select(x => x.sitetree.currentSite);
			const livePageConf = yield select(x => x.live.livePageConf);
			if(columnHeaders && columnHeaders.length && currentSite && livePageConf.ticketsIncluded){
				let startOfDay = columnHeaders[columnHeaders.length - 1].startOfDay;
				let endOfDay = columnHeaders[columnHeaders.length - 1].endOfDay;
				let dailyTickets = yield call(ticketservice.GetTicketsSold, [currentSite.name], startOfDay, endOfDay);
				let liveTickets = 0;
				if(dailyTickets instanceof Error) {
					yield put(actions.updateLiveTicketsFailed(dailyTickets));
				} else {
					if(dailyTickets){
						let wkSiteName = 's' + currentSite.name.substring(1);
						liveTickets = dailyTickets[wkSiteName] ? dailyTickets[wkSiteName] : 0;
						yield put(actions.updateLiveTickets(liveTickets));
					}
				}
			}
		});
	},
	*loadUsageHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS], function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const usagePointId = yield select(x => x.weeklysummarytable.usagePointId);
			let usage = new Array(DAYS);
			if(columnHeaders && columnHeaders.length > 0 && usagePointId){
				let fromDate = columnHeaders[0].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyUsage = yield call(getUsage, usagePointId, fromDate, toDate);
				if(dailyUsage && dailyUsage.length){
					usage = [];
					dailyUsage.forEach(s => {
						usage.push(s.value)
					});
				}
			}
			yield put(actions.setUsage(usage));
		});
	},
	*updateLiveUsage(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const usagePointId = yield select(x => x.weeklysummarytable.usagePointId);
			if(columnHeaders && columnHeaders.length > 0 && usagePointId){
				let fromDate = columnHeaders[columnHeaders.length - 1].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyUsage = yield call(getUsage, usagePointId, fromDate, 'now');
				if(dailyUsage && dailyUsage.length && dailyUsage[0].value !== undefined && dailyUsage[0].value !== null){
					let liveUsage = dailyUsage[0].value;
					yield put(actions.updateLiveUsage(liveUsage));
				}
			}
		});
	},
	*loadAmbientMinHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS], function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			let ambientMin= new Array(DAYS);
			if(columnHeaders && columnHeaders.length > 0 && ambientTemperaturePointId){
				let fromDate = columnHeaders[0].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientMin = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, toDate, null, null, "Daily", true, true, "Minimum");
				
				if(dailyAmbientMin && dailyAmbientMin.length){
					ambientMin = [];
					dailyAmbientMin.forEach(s => {
						ambientMin.push(s.value)
					});
				}
			}
			yield put(actions.setAmbientMin(ambientMin));
		});
	},
	*updateLiveAmbientMin(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			if(columnHeaders && columnHeaders.length > 0 && ambientTemperaturePointId){
				let fromDate = columnHeaders[columnHeaders.length - 1].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientMin = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, 'now', null, null, "Daily", true, true, "Minimum");
				if(dailyAmbientMin && dailyAmbientMin.length && dailyAmbientMin[0].value !== undefined && dailyAmbientMin[0].value !== null){
					let liveAmbientMin = dailyAmbientMin[0].value;
					yield put(actions.updateLiveAmbientMin(liveAmbientMin));
				}
			}
		});
	},
	*loadAmbientAvgHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS], function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			let ambientAvg= new Array(DAYS);
			if(columnHeaders && columnHeaders.length && ambientTemperaturePointId){
				let fromDate = columnHeaders[0].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientAvg = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, toDate, null, null, "Daily", true, true, "Average");
				if(dailyAmbientAvg && dailyAmbientAvg.length){
					ambientAvg = [];
					dailyAmbientAvg.forEach(s => {
						ambientAvg.push(s.value)
					});
				}
			}
			yield put(actions.setAmbientAvg(ambientAvg));
		});
	},
	*updateLiveAmbientAvg(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			if(columnHeaders && columnHeaders.length > 0 && ambientTemperaturePointId){
				let fromDate = columnHeaders[columnHeaders.length - 1].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientAvg = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, 'now', null, null, "Daily", true, undefined, "Average");
				if(dailyAmbientAvg && dailyAmbientAvg.length && dailyAmbientAvg[0].value !== undefined && dailyAmbientAvg[0].value !== null){
					let liveAmbientAvg = dailyAmbientAvg[0].value;
					yield put(actions.updateLiveAmbientAvg(liveAmbientAvg));
				}
			}
		});
	},
	*loadAmbientMaxHistory(){
		yield takeLatest([types.SET_COLUMN_HEADERS, types.SET_POINT_IDS], function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			let ambientMax= new Array(DAYS);
			if(columnHeaders && columnHeaders.length > 0 && ambientTemperaturePointId){
				let fromDate = columnHeaders[0].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientMax = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, toDate, null, null, "Daily", true, undefined, "Maximum");
				if(dailyAmbientMax && dailyAmbientMax.length){
					ambientMax = [];
					dailyAmbientMax.forEach(s => {
						ambientMax.push(s.value)
					});
				}
			}
			yield put(actions.setAmbientMax(ambientMax));
		});
	},
	*updateLiveAmbientMax(){
		yield takeLeading(types.UPDATE_LIVE_DATA, function*(){
			const columnHeaders = yield select(x => x.weeklysummarytable.columnHeaders);
			const ambientTemperaturePointId = yield select(x => x.weeklysummarytable.ambientTemperaturePointId);
			if(columnHeaders && columnHeaders.length > 0 && ambientTemperaturePointId){
				let fromDate = columnHeaders[columnHeaders.length - 1].startOfDay;
				let toDate = columnHeaders[columnHeaders.length - 1].endOfDay;
				const dailyAmbientMax = yield call(pointsservice.TrendableDataGetData, ambientTemperaturePointId, fromDate, 'now', null, null, "Daily", true, undefined, "Maximum");
				if(dailyAmbientMax && dailyAmbientMax.length && dailyAmbientMax[0].value !== undefined && dailyAmbientMax[0].value !== null){
					let liveAmbientMax = dailyAmbientMax[0].value;
					yield put(actions.updateLiveAmbientMax(liveAmbientMax));
				}
			}
		});
	},
};

////////
//actions
export const actions = {
	startComponent(){
		return {
			type: types.START_COMPONENT,
			payload: {}
		};
	},
	stopComponent(){
		return {
			type: types.STOP_COMPONENT,
			payload: {}
		};
	},
	setColumnHeaders(columnHeaders){
		return {
			type: types.SET_COLUMN_HEADERS,
			payload: {columnHeaders}
		};
	},
	updateColumnHeaders(){
		return {
			type: types.UPDATE_COLUMN_HEADERS,
			payload: {},
		};
	},
	setPointIds(usagePointId, ambientTemperaturePointId){
		return {
			type: types.SET_POINT_IDS,
			payload: {usagePointId, ambientTemperaturePointId}
		};
	},
	updateLiveData(){
		return {
			type: types.UPDATE_LIVE_DATA,
			payload: {}
		};
	},
	setCosts(costs){
		return {
			type: types.SET_COSTS,
			payload: {costs}
		};
	},
	setTickets(tickets){
		return {
			type: types.SET_TICKETS,
			payload: {tickets}
		};
	},
	setUsage(usage){
		return {
			type: types.SET_USAGE,
			payload: {usage}
		};
	},
	setAmbientMin(ambientMin){
		return {
			type: types.SET_AMBIENT_MIN,
			payload: {ambientMin}
		};
	},
	setAmbientAvg(ambientAvg){
		return {
			type: types.SET_AMBIENT_AVG,
			payload: {ambientAvg}
		};
	},
	setAmbientMax(ambientMax){
		return {
			type: types.SET_AMBIENT_MAX,
			payload: {ambientMax}
		};
	},
	updateLiveCost(liveCost){
		return {
			type: types.UPDATE_LIVE_COSTS,
			payload: {liveCost}
		};
	},
	updateLiveUsage(liveUsage){
		return {
			type: types.UPDATE_LIVE_USAGE,
			payload: {liveUsage}
		};
	},
	updateLiveTickets(liveTickets){
		return {
			type: types.UPDATE_LIVE_TICKETS,
			payload: {liveTickets}
		};
	},
	updateLiveAmbientMin(liveAmbientMin){
		return {
			type: types.UPDATE_LIVE_AMBIENT_MIN,
			payload: {liveAmbientMin}
		};
	},
	updateLiveAmbientAvg(liveAmbientAvg){
		return {
			type: types.UPDATE_LIVE_AMBIENT_AVG,
			payload: {liveAmbientAvg}
		};
	},
	updateLiveAmbientMax(liveAmbientMax){
		return {
			type: types.UPDATE_LIVE_AMBIENT_MAX,
			payload: {liveAmbientMax}
		};
	},

	updateLiveTicketsFailed(payload) {
		return {
			type: types.UPDATE_LIVE_TICKETS_FAILED,
			payload
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/LiveComponents/WeeklySummaryTable/redux.js